import "./App.sass";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./components/MainPage";
import Footer from "./components/Footer";
import Service from "./components/Service";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import MainNav from "./components/header/MainNav";
import { Helmet } from "react-helmet";
import accident from "./components/img/accident.svg";
import car from "./components/img/car.svg";
import fireTruck from "./components/img/fireTruck.svg";
import wheel from "./components/img/wheel.svg";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    console.log(
      "%cStrona stworzona przez:",
      "color: #ffffff; font-size: 24px; font-weight: bold; text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7); background-color: #333333; padding: 10px; border-radius: 8px; font-family: 'Arial', sans-serif; box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);"
    );

    console.log(
      "%cSzymon Ekman: https://github.com/szymonqqq",
      "color: #ffffff; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7); background-color: #333333; padding: 10px; border-radius: 8px; font-family: 'Arial', sans-serif; box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);"
    );

    console.log(
      "%cPaweł Kowalski: https://github.com/pawel4985",
      "color: #ffffff; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7); background-color: #333333; padding: 10px; border-radius: 8px; font-family: 'Arial', sans-serif; box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);"
    );
  });
  return (
    <GoogleReCaptchaProvider reCaptchaKey='6LcHot8qAAAAAPR-FwWhaATCtxKqLcxZT8eRAVXa'>
      <div className='App'>
        <Helmet>
          <meta name='language' content='pl' />
          <meta name='copyright' content='Boro Cars' />
          <meta name='url' content='http://borocars.pl' />
          <meta name='identifier-URL' content='http://borocars.pl' />
          <meta name='robots' content='index,follow' />
          <meta
            name='subject'
            content='Profesjonalne naprawy i usługi mechaniczne na najwyższym poziomie.'
          />
          <meta name='reply-to' content='mateusz.borolewski@interia.pl' />
          <meta name='owner' content='Mateusz Borolewski' />
          <meta name='target' content='all' />
          <meta name='HandheldFriendly' content='True' />
          <meta name='medium' content='website' />
          <meta
            name='keywords'
            content='mechanik Dragacz, mechanik Grudziądz, naprawy samochodów, wulkanizacja, naprawa pojazdów specjalistycznych, naprawa samochodów osobowych, blacharka samochodowa, blacharz, serwis Grudziądz, naprawa aut Dragacz'
          />
          <meta
            name='description'
            content='Profesjonalna naprawa samochodów osobowych w pobliżu Grudziądza, blacharstwo, wulkanizacja oraz naprawa pojazdów specjalistycznych. Sprawdź naszą ofertę i umów się na wizytę!'
          />
          <meta property='og:title' content='Boro cars' />
          <title>Boro Cars – Profesjonalna Obsługa Mechaniczna</title>
        </Helmet>

        <BrowserRouter>
          <MainNav />

          <Routes>
            <Route
              path='/'
              element={
                <>
                  <MainPage />
                  <Helmet>
                    <title>Boro Cars – Profesjonalna Obsługa Mechaniczna</title>
                    <meta
                      name='description'
                      content='Witamy w Boro Cars! Oferujemy kompleksowe usługi motoryzacyjne.'
                    />
                  </Helmet>
                </>
              }
            />
            <Route
              path='/wulkanizacja'
              element={
                <>
                  <Service
                    title='Wulkanizacja w Dragaczu pomocna dla kierowców z Grudziądza'
                    description='Wymiana opon lub naprawa? Nasz warsztat wulkanizacyjny w Dragaczu zapewnia szybką i skuteczną pomoc. Działamy dla klientów z Grudziądza i okolic doświadczony zespół, krótkie terminy i bezpieczeństwo na drodze. Sprawdź naszą wulkanizację!'
                    image={wheel}
                  />
                  <Helmet>
                    <title>Boro Cars - Wulkanizacja</title>
                    <meta
                      name='description'
                      content='Profesjonalne usługi wulkanizacyjne w Boro Cars.'
                    />
                  </Helmet>
                </>
              }
            />
            <Route
              path='/blacharstwo'
              element={
                <>
                  <Service
                    title='Blacharstwo samochodowe fachowa naprawa dla Grudziądza i okolic'
                    description='Usuwamy każdą rysę, wgniecenie czy korozję sprawnie i z dbałością o detale. Nasi specjaliści w Dragaczu gwarantują doskonały efekt. Klienci z Grudziądza wybierają nasze blacharstwo ze względu na szybkość i jakość. Zaufaj nam przy naprawie aut!'
                    image={accident}
                  />
                  <Helmet>
                    <title>Boro Cars - Blacharstwo samochodowe</title>
                    <meta
                      name='description'
                      content='Blacharstwo samochodowe w Boro Cars - naprawa karoserii.'
                    />
                  </Helmet>
                </>
              }
            />
            <Route
              path='/osobowe'
              element={
                <>
                  <Service
                    title='Naprawa samochodów osobowych sprawdzony mechanik z Dragacza'
                    description='Dobry mechanik to podstawa, dlatego stawiamy na zespół ekspertów. W Dragaczu zajmujemy się każdą usterką od drobnych napraw po naprawę silników. Klienci z Grudziądza doceniają naszą jakość sprawdź, dlaczego uznają nas za najlepszy warsztat w regionie!'
                    image={car}
                  />
                  <Helmet>
                    <title>Boro Cars - Naprawa samochodów osobowych</title>
                    <meta
                      name='description'
                      content='Profesjonalna naprawa samochodów osobowych w Boro Cars.'
                    />
                  </Helmet>
                </>
              }
            />
            <Route
              path='/specjalistyczne'
              element={
                <>
                  <Service
                    title='Profesjonalna naprawa pojazdów specjalistycznych w Dragaczu'
                    description='Specjalizujemy się w naprawie pojazdów specjalistycznych, takich jak samochody pożarnicze czy auta policyjne. Nasz zespół w Dragaczu (marka Borolewski, Boro Cars) działa szybko i profesjonalnie. Świadczymy usługi również dla klientów z Grudziądza zapraszamy po kompleksową naprawę silników i skomplikowanych usterek.'
                    image={fireTruck}
                  />
                  <Helmet>
                    <title>
                      Boro Cars - Naprawa pojazdów specjalistycznych
                    </title>
                    <meta
                      name='description'
                      content='Kompleksowa naprawa pojazdów specjalistycznych w Boro Cars.'
                    />
                  </Helmet>
                </>
              }
            />
            <Route path='/*' element={<Navigate to='/' replace />} />
          </Routes>
        </BrowserRouter>

        <Footer />
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
